import { styled } from '../styled';

export const ContentStyled = styled('div')(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '18px 48px',
  justifyContent: 'space-evenly',
}));
